import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "app__nav-left" }
const _hoisted_2 = ["tabindex", "aria-label"]
const _hoisted_3 = { class: "app__nav-logo" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "app__nav-progress" }
const _hoisted_6 = { class: "app__nav-right" }
const _hoisted_7 = ["aria-label", "tabindex"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = {
  key: 2,
  class: "share__modal"
}
const _hoisted_11 = { class: "share__title" }
const _hoisted_12 = { class: "share__subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "share__socials"
}
const _hoisted_14 = ["aria-label", "href"]
const _hoisted_15 = ["aria-label", "href"]
const _hoisted_16 = ["aria-label", "href"]
const _hoisted_17 = ["aria-label", "href"]
const _hoisted_18 = { class: "share__embed" }
const _hoisted_19 = { class: "share__embed-code" }
const _hoisted_20 = { class: "share__embed-button-wrapper" }
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = {
  key: 0,
  class: "share__embed-message share__embed-message--succes"
}
const _hoisted_23 = {
  key: 1,
  class: "share__embed-message share__embed-message--fail"
}
const _hoisted_24 = ["aria-label"]

import { Ref, ref, computed, watch } from "vue";
import useClipboard from "vue-clipboard3";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useGetters } from "vuex-composition-helpers";

import RSInject from "@/modules/rsinject/components/RSInject.vue";
import { IStatement, IStoreGetters } from "../interfaces";
import { config, dictionary, votematch } from "../constants";
import { slugify, statementTitleToString } from "../helpers";
import { useShootoutStatements, useShareLink } from "../composables";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNav',
  setup(__props) {

const { toClipboard } = useClipboard();

const route = useRoute();
const router = useRouter();
const store = useStore();
const { statements } = useGetters<IStoreGetters>(["statements"]);
const shootoutStatements = useShootoutStatements();
const shareLink = useShareLink();

const shareModalOpen: Ref<boolean> = ref(false);
const shareSuccess: Ref<boolean> = ref(false);
const shareFail: Ref<boolean> = ref(false);

const indicatorWidth = computed(function (): number {
  if (hideNav.value) return 0;
  if (route.name === "statement") {
    return (
      (100 / (statements.value.length + 3)) *
      JSON.parse(route.params.id.toString())
    );
  } else if (route.name === "shootout-statement") {
    return (
      (100 / shootoutStatements.value.length) *
      JSON.parse(route.params.id.toString())
    );
  } else if (route.name === "select-statements") {
    return (
      (100 / (statements.value.length + 3)) *
      (statements.value.length +
        (store.getters.showAnalyticsQuestion ? 1 : 1.5))
    );
  } else if (route.name === "select-parties") {
    return store.getters.showAnalyticsQuestion
      ? (100 / (statements.value.length + 3)) * (statements.value.length + 2)
      : 100;
  } else if (
    route.name === "select-analytics" ||
    route.name === "results" ||
    route.name === "choices-overview"
  ) {
    return 100;
  }

  return 0;
});

const disableNavButtons = computed(function (): boolean {
  if (hideNav.value) return true;
  if (
    route.name === "statement" &&
    route.params.id === "1" &&
    config.settings.skipStart
  )
    return true;

  return false;
});

const embedCode = computed(function (): string {
  if (route.name === "statement") {
    return `<iframe title="${dictionary.app.title}" width="1080" height="810" src="${window.location.protocol}//${window.location.host}?${slugify(dictionary.statement.tabTitle)}=${route.params.id}"></iframe>`;
  } else {
    return `<iframe title="${dictionary.app.title}" width="1080" height="810" src="${window.location.protocol}//${window.location.host}"></iframe>`;
  }
});

const hideNav = computed(function (): boolean {
  if (route.name === "start") return true;
  return false;
});

const showShareButtons = computed(function (): boolean {
  if (route.name === "statement") {
    if (!dictionary.statement.share) return false;

    return dictionary.statement.share.facebookWithStatement ||
      dictionary.statement.share.twitterWithStatement ||
      dictionary.statement.share.linkedinWithStatement ||
      dictionary.statement.share.whatsappWithStatement
      ? true
      : false;
  } else {
    if (!dictionary.app.share) return false;

    return dictionary.app.share.facebook ||
      dictionary.app.share.twitter ||
      dictionary.app.share.linkedin ||
      dictionary.app.share.whatsapp
      ? true
      : false;
  }
});

const shareTitle = computed(function (): string {
  if (
    route.name === "statement" &&
    dictionary.statement.share &&
    dictionary.statement.share.title
  ) {
    return dictionary.statement.share.title;
  } else if (dictionary.app.share.title) {
    return dictionary.app.share.title;
  } else {
    return "";
  }
});

const shareSubtitle = computed(function (): string {
  if (
    route.name === "statement" &&
    dictionary.statement.share &&
    dictionary.statement.share.subtitle
  ) {
    return dictionary.statement.share.subtitle;
  } else if (dictionary.app.share.subtitle) {
    return dictionary.app.share.subtitle;
  } else {
    return "";
  }
});

watch(shareModalOpen, () => {
  if (!shareModalOpen.value) {
    shareSuccess.value = false;
    shareFail.value = false;
  }
});
watch(route, () => {
  shareModalOpen.value = false;
});
function back() {
  shareModalOpen.value = false;

  if (route.name === "statement" || route.name === "shootout-statement") {
    if (route.params.id === "1") {
      if (route.name === "shootout-statement") {
        router.push({
          name: "results",
        });
      } else {
        if (!config.settings.skipStart) {
          router.push({
            name: "start",
          });
        }
      }
    } else {
      router.push({
        name:
          route.name === "shootout-statement"
            ? "shootout-statement"
            : "statement",
        params: {
          id: JSON.stringify(JSON.parse(route.params.id.toString()) - 1),
          title: slugify(
            statementTitleToString(
              store.getters.statement(
                JSON.parse(route.params.id.toString()) - 1,
              ).title,
            ),
          ),
        },
      });
    }
  } else if (route.name === "select-statements") {
    toLastStatement();
  } else if (route.name === "select-parties") {
    if (config.settings.maxSelectedStatements) {
      router.push({ name: "select-statements" });
    } else {
      toLastStatement();
    }
  } else if (route.name === "select-analytics") {
    router.push({ name: "select-parties" });
  } else if (route.name === "results") {
    router.push({
      name: store.getters.showAnalyticsQuestion
        ? "select-analytics"
        : "select-parties",
    });
  } else if (route.name === "choices-overview") {
    router.push({ name: "results" });
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function next() {
  shareModalOpen.value = false;
}
function copyEmbedCode() {
  toClipboard(embedCode.value)
    .then(() => {
      shareModalOpen.value = true;
      shareSuccess.value = true;
    })
    .catch(() => {
      shareModalOpen.value = true;
      shareFail.value = true;
    });
}
function toLastStatement(): void {
  const lastStatementId = statements.value.length;
  router.push({
    name: "statement",
    params: {
      id: JSON.stringify(lastStatementId),
      title: slugify(
        statementTitleToString(
          (store.getters.statement(lastStatementId) as IStatement).title,
        ),
      ),
    },
  });
}

// This used to be in the 'created'  function
document.addEventListener("keyup", (e) => {
  if (e.code === "Escape") {
    shareModalOpen.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["app__nav", {
      'app__nav--hidden': hideNav.value,
      'app__nav--choices-overview': _unref(route).name === 'choices-overview',
      'with-ad': _unref(config).settings.showAd,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["button button--back", { 'button--disabled': disableNavButtons.value }]),
        onClick: back,
        tabindex: disableNavButtons.value ? '-1' : '0',
        "aria-label": _unref(dictionary).app.accessibility.back
      }, null, 10, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          alt: _unref(dictionary).app.logoAlt,
          src: 'gfx/img/' + _unref(config).style.logo + '?vmid=' + _unref(votematch).id
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", {
        class: "app__nav-progress-indicator",
        style: _normalizeStyle('width: ' + indicatorWidth.value + '%')
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_unref(config).settings.readspeaker?.show)
        ? (_openBlock(), _createBlock(RSInject, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["app__nav-counter", {
          'app__nav-counter--hidden':
            _unref(route).name === 'results' || _unref(route).name === 'choices-overview',
        }])
      }, [
        _createElementVNode("strong", null, _toDisplayString(_unref(route).name === "start"
              ? "1"
              : _unref(route).name === "statement" ||
                  _unref(route).name === "shootout-statement"
                ? _unref(route).params.id
                : Object.values(_unref(statements)).length) + "/", 1),
        _createTextVNode(_toDisplayString(_unref(route).name === "shootout-statement"
            ? Object.values(_unref(shootoutStatements)).length
            : Object.values(_unref(statements)).length), 1)
      ], 2),
      (_unref(config).settings.showShareMenu)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: _normalizeClass(["app__nav-share-button button button--share", {
          'button--disabled': disableNavButtons.value,
          'app__nav-share-button--hidden': _unref(route).name === 'results',
        }]),
            "aria-label": 
          _unref(dictionary).app.accessibility.shareButtonName +
          (shareModalOpen.value
            ? ', ' + _unref(dictionary).app.accessibility.opened
            : ', ' + _unref(dictionary).app.accessibility.closed)
        ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (shareModalOpen.value = !shareModalOpen.value)),
            tabindex: disableNavButtons.value ? '-1' : '0'
          }, null, 10, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: _unref(config).style.clientLogoUrl,
        target: "_blank",
        rel: "nofollow",
        class: "app__nav-client-logo"
      }, [
        _createElementVNode("img", {
          alt: _unref(dictionary).app.clientLogoAlt,
          src: 'gfx/img/' + _unref(config).style.clientLogoBlack
        }, null, 8, _hoisted_9)
      ], 8, _hoisted_8),
      (shareModalOpen.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString(shareTitle.value), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(shareSubtitle.value), 1),
            (showShareButtons.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (
              _unref(route).name === 'statement'
                ? _unref(dictionary).statement.share?.facebookWithStatement
                : _unref(dictionary).app.share.facebook
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "share__social-button share__social-button--facebook",
                        "aria-label": _unref(dictionary).app.share.accessibility.facebookButtonLabel,
                        tabindex: "0",
                        href: _unref(shareLink)('facebook'),
                        target: "_blank"
                      }, null, 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (
              _unref(route).name === 'statement'
                ? _unref(dictionary).statement.share?.twitterWithStatement
                : _unref(dictionary).app.share.twitter
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "share__social-button share__social-button--twitter",
                        "aria-label": _unref(dictionary).app.share.accessibility.twitterButtonLabel,
                        tabindex: "0",
                        href: _unref(shareLink)('twitter'),
                        target: "_blank"
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (
              _unref(route).name === 'statement'
                ? _unref(dictionary).statement.share?.linkedinWithStatement
                : _unref(dictionary).app.share.linkedin
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "share__social-button share__social-button--linkedin",
                        "aria-label": _unref(dictionary).app.share.accessibility.linkedinButtonLabel,
                        tabindex: "0",
                        href: _unref(shareLink)('linkedin'),
                        target: "_blank"
                      }, null, 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (
              _unref(route).name === 'statement'
                ? _unref(dictionary).statement.share?.whatsappWithStatement
                : _unref(dictionary).app.share.whatsapp
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        class: "share__social-button share__social-button--whatsapp",
                        "aria-label": _unref(dictionary).app.share.accessibility.whatsappButtonLabel,
                        tabindex: "0",
                        href: _unref(shareLink)('whatsapp'),
                        target: "_blank"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(embedCode.value), 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "share__embed-button",
                  "aria-label": _unref(dictionary).app.share.copyEmbedCode,
                  tabindex: "0",
                  onClick: copyEmbedCode
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "overlay" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(dictionary).app.share.copyEmbedCode), 1)
                ], 8, _hoisted_21),
                (shareSuccess.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(dictionary).app.share.copyEmbedCodeSucces), 1))
                  : _createCommentVNode("", true),
                (shareFail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(dictionary).app.share.copyEmbedCodeFail), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("button", {
              class: "share__close",
              "aria-label": _unref(dictionary).app.closeModal,
              tabindex: "0",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (shareModalOpen.value = false))
            }, _toDisplayString(_unref(dictionary).app.closeModal), 9, _hoisted_24)
          ])), [
            [_directive_click_away, () => (shareModalOpen.value = false)]
          ])
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})